import React from "react";
import PropTypes from "prop-types";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const InitialsAvatar = ({ name }) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  const initial =
    parts.length >= 2
      ? (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
      : (parts[0]?.charAt(0) || "?").toUpperCase();
  return (
    <div className="w-[32px] h-[32px] rounded-full bg-primary-soft flex items-center justify-center text-primary font-semibold text-base shrink-0">
      {initial}
    </div>
  );
};
InitialsAvatar.propTypes = { name: PropTypes.string };

const formatDateTime = (dateString) => {
  if (!dateString) return { date: "—", time: "" };
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return { date: "—", time: "" };
  const date = d.toLocaleDateString("en-GB", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const time = d.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  });
  return { date, time };
};

const RequesterPanel = ({ requesterName, requesterTitle, createdAt }) => {
  const submitted = formatDateTime(createdAt);

  return (
    <div className="bg-card border border-card-bd rounded-card p-5">
      <div className="flex items-center gap-2 mb-4">
        <FontAwesomeIcon
          icon={icon({ name: "user", family: "sharp", style: "light" })}
          className="text-text-2 text-sm"
        />
        <h3 className="text-sm font-semibold text-text">Requester</h3>
      </div>

      <div className="flex items-center gap-3">
        <InitialsAvatar name={requesterName} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-text truncate">
            {requesterName || "Unknown"}
          </p>
          {requesterTitle && (
            <p className="text-xs text-text-2 mt-0.5 truncate">
              {requesterTitle}
            </p>
          )}
        </div>
      </div>

      <div className="mt-3 pt-3 border-t border-border">
        <p className="text-xs text-text-2">Submitted</p>
        <p className="text-sm font-medium text-text">{submitted.date}</p>
        {submitted.time && (
          <p className="text-xs text-text-2">{submitted.time}</p>
        )}
      </div>
    </div>
  );
};

RequesterPanel.propTypes = {
  requesterName: PropTypes.string,
  requesterTitle: PropTypes.string,
  createdAt: PropTypes.string,
};

export default RequesterPanel;
